import { ViewHook } from "phoenix_live_view";

const REVEAL_RATIO = 0.2;

class ReportReveal extends ViewHook {
  declare observer: IntersectionObserver;

  mounted() {
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      threshold: [0, REVEAL_RATIO],
    });

    for (const target of this.el.querySelectorAll("[data-reveal]")) {
      this.observer.observe(target);
    }
  }

  destroyed() {
    this.observer.disconnect();
  }

  private onIntersect(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      const target = entry.target as HTMLElement;

      if (entry.intersectionRatio >= REVEAL_RATIO) {
        target.dataset.revealed = "";
      } else if (!entry.isIntersecting) {
        delete target.dataset.revealed;
      }
    }
  }
}

export default ReportReveal;
